import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useTheme,
  alpha
} from '@mui/material';
import {
  Campaign as CampaignIcon,
  ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';
import { tourConfig } from './tourConfig';

const WhatsNewModal = ({ open, tourId, onSkip, onStartTour }) => {
  const theme = useTheme();
  const config = tourConfig[tourId];
  if (!config) return null;

  return (
    // No onClose: backdrop clicks and Escape don't dismiss it, the user picks Skip or Take a Tour
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      aria-labelledby="whats-new-title"
      aria-describedby="whats-new-description"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow: `0 24px 48px ${alpha(theme.palette.common.black, 0.2)}`,
        }
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          color: theme.palette.primary.contrastText,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            bgcolor: alpha(theme.palette.common.white, 0.2),
            borderRadius: '50%',
            p: 1.5,
            mb: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CampaignIcon sx={{ fontSize: 40 }} />
        </Box>
        <Typography id="whats-new-title" variant="h5" sx={{ fontWeight: 700, textAlign: 'center' }}>
          {config.title}
        </Typography>
      </Box>

      <DialogContent sx={{ p: 4, textAlign: 'center' }}>
        <Typography id="whats-new-description" variant="body1" color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
          {config.description}
        </Typography>
        <Typography variant="body2" color="text.primary" sx={{ fontWeight: 500 }}>
          Would you like a quick tour of what's new?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0, justifyContent: 'space-between' }}>
        <Button 
          onClick={onSkip} 
          color="inherit" 
          sx={{ 
            color: theme.palette.text.secondary,
            textTransform: 'none',
            fontWeight: 600
          }}
        >
          Skip
        </Button>
        <Button
          onClick={() => onStartTour(tourId)}
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            borderRadius: 2,
            px: 3,
            textTransform: 'none',
            fontWeight: 700,
            boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        >
          Take a Tour
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsNewModal;
